import React, { useEffect, useState } from 'react';
import { Spinner } from '@panel/commons/lib/Spinner/Spinner';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { ModalBase } from '@panel/commons';
import { useDispatch, useSelector } from 'react-redux';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';
import ErrorScreen from '@panel/commons/lib/ErrorScreen/ErrorScreen';
import UnreadLeadsModal from '@panel/commons/lib/Modals/UnreadLeadsModal';
import { sendCustomTrackingInfo } from '@panel/commons/lib/sendTrackingInfo';
import EmptyState from '../EmptyState/EmptyState';
import EmptySearch from '../EmptyState/EmptySearch';
import PostingCard from './PostingCard/PostingCard';
import PostingsHeader from './PostingsHeader/PostingsHeader';
import PostingDetail from './PostingCard/PostingDetails';
import { Modal } from '../Modals/ModalWrapper';
import LockedManualModal from '../Modals/LockedManualModal';
import useUrlSearchParams from '../hooks/useUrlSearchParams';
import Pagination from '../PostingsListDesktop/Pagination/Pagination';
import { UnreadLeadsMsgOperations, UnreadLeadsMsgSelectors } from '../../../ducks/unreadLeadsMsg';
import { SuspendSelectors } from '../../../ducks/suspend';
import { ArchiveSelectors } from '../../../ducks/archive';

function PostingsListMobile({
  postingsData,
  setFinishedAction,
  hasFilters,
  finishedAction,
  userCanEditPermissions,
  publisherTypeId,
  loadingAction,
  page,
  setPage,
  limit,
  numberOfPostings,
  getPostings,
  isVAPublisher
}) {
  const isZPARSite = process.env.REACT_APP_BUILD_SITE.includes('AR');
  const dispatch = useDispatch();
  const [postingSelected, setPostingSelected] = useState(null);
  const [enableUnreadLeadsModal, setEnableUnreadLeadsModal] = useState(false);

  const { lockedManual } = useSelector(userInfoSelectors.getuserInfoState);
  const { showUnreadLeadsModal, sendUnreadLeadsMsgLoading, comesFromArchive } = useSelector(
    UnreadLeadsMsgSelectors.getUnreadLeadsMsgState
  );
  const { recievedSuccessfulResponse: suspendRecievedSuccessfulResponse } = useSelector(
    SuspendSelectors.getSuspendState
  );
  const { recievedSuccessfulResponse: archiveRecievedSuccessfulResponse } = useSelector(
    ArchiveSelectors.getArchiveState
  );
  const [lockedManualModal, setLockedManualModal] = useState(false);
  const history = useHistory();
  const { formatedUrlFilters, chargeAppliedFilters } = useUrlSearchParams();
  const handleDeviceBackButton = () => {
    setPostingSelected(null);
  };

  const closeSingleView = () => {
    history.go(-1);
    setPostingSelected(null);
  };
  useEffect(() => {
    window.addEventListener('popstate', handleDeviceBackButton);
    return () => {
      window.removeEventListener('popstate', handleDeviceBackButton);
    };
  }, []);

  useEffect(() => {
    if (formatedUrlFilters.length > 0) {
      chargeAppliedFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formatedUrlFilters]);

  useEffect(() => {
    if (postingSelected) {
      const [postingUpdated] = postingsData.postings.filter(post => post.postingId === postingSelected.postingId);
      setPostingSelected(postingUpdated);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingsData.postings]);

  const emptyNotFetching =
    !postingsData.isLoading &&
    !postingsData.postings.length &&
    !postingsData.fetchError &&
    postingsData.recievedPostingsResponse;

  // EFECTO PARA MOSTRAR SNACKBAR DE ÉXITO EN ACCIÓN DE FINALIZADO O PUBLICACIÓN DE POSTING
  useEffect(() => {
    if (finishedAction.result) {
      closeSingleView();
    }
    return () => {
      // SANEAMIENTO DEL STATE QUE DISPARA EL EFECTO
      setFinishedAction({ postingId: '', action: '', result: '', isParticularNotFree: false });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finishedAction.result]);

  const openDetailPosting = (posting, postingIndex) => {
    const querystringMD = window.location.search;
    const params = new URLSearchParams(querystringMD);
    params.set('postingId', posting.postingId);
    // SE AGREGA UNA ENTRADA A LA HISTORY SOLO AL EFECTO DE HACER QUE EL BACK DE ANDROID CIERRE EL POSTING Y NO REDIRIJA A HOME
    history.push({
      search: params.toString()
    });
    setPostingSelected({ ...posting, postingIndex });
  };

  useEffect(() => {
    if (lockedManual) {
      setLockedManualModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lockedManual]);

  useEffect(() => {
    if (showUnreadLeadsModal && (suspendRecievedSuccessfulResponse || archiveRecievedSuccessfulResponse)) {
      setEnableUnreadLeadsModal(showUnreadLeadsModal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showUnreadLeadsModal, suspendRecievedSuccessfulResponse, archiveRecievedSuccessfulResponse]);

  return (
    <div>
      <PostingsHeader
        emptyNotFetching={emptyNotFetching}
        postingsCount={postingsData.postingCount}
        hasFilters={hasFilters}
        isVAPublisher={isVAPublisher}
        publisherTypeId={publisherTypeId}
      />

      {lockedManualModal && (
        <Modal>
          <ModalBase
            openModal={lockedManualModal}
            onClose={() => setLockedManualModal(false)}
            width='85%'
            height={isZPARSite ? 'fit-content' : '399px'}
          >
            <LockedManualModal onClose={() => setLockedManualModal(false)} isZPARSite={isZPARSite} />
          </ModalBase>
        </Modal>
      )}
      {enableUnreadLeadsModal && (
        <Modal>
          <ModalBase
            openModal={enableUnreadLeadsModal}
            onClose={() => {
              dispatch(UnreadLeadsMsgOperations.setShowUnreadLeadsModal(false, [], false));
              setEnableUnreadLeadsModal(false);
              sendCustomTrackingInfo({
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: `${comesFromArchive ? 'Archivar' : 'Finalizar'} Aviso-enviar_cerrar`
              });
            }}
            isLoading={sendUnreadLeadsMsgLoading}
            withoutOutsideClose
          >
            <UnreadLeadsModal
              device='mobile'
              onClose={() => {
                dispatch(UnreadLeadsMsgOperations.setShowUnreadLeadsModal(false, [], false));
                setEnableUnreadLeadsModal(false);
              }}
              publisherTypeId={publisherTypeId}
              publisherId={postingSelected && postingSelected.publisherId}
              UnreadLeadsMsgOperations={UnreadLeadsMsgOperations.sendUnreadLeadsMessagge}
              UnreadLeadsMsgSelectors={UnreadLeadsMsgSelectors.getUnreadLeadsMsgState}
              comesFromArchive={comesFromArchive}
            />
          </ModalBase>
        </Modal>
      )}

      {!postingsData.fetchError && postingsData.postings.length > 0 && (
        <>
          <PostingsListWrapper>
            {postingsData.postings.map((posting, postingIndex) => (
              <PostingCard
                finishedAction={finishedAction}
                postingStatus={posting.stateAndDates[0].status}
                loadingLeads={posting.loadingLeads}
                loadingQuality={posting.loadingQuality}
                loadingVisits={posting.loadingVisits}
                openDetailPosting={() => openDetailPosting(posting, postingIndex)}
                key={posting.postingId}
                posting={{ ...posting, postingIndex }}
                isParticular={publisherTypeId === '1'}
              />
            ))}
          </PostingsListWrapper>
        </>
      )}
      {(postingsData.isLoading || loadingAction) && (
        <div>
          <SpinnerWrapper>
            <Spinner />
          </SpinnerWrapper>
        </div>
      )}
      {postingsData.fetchError && <ErrorScreen handleOnclick={getPostings} />}
      {emptyNotFetching && !hasFilters && <EmptyState />}
      {emptyNotFetching && hasFilters && <EmptySearch />}
      {postingSelected && (
        <PostingDetail
          userCanEditPermissions={userCanEditPermissions}
          posting={postingSelected}
          onClose={closeSingleView}
          publisherTypeId={publisherTypeId}
          finishReason={postingsData.finishReason}
        />
      )}
      {postingsData.postings.length > 0 && numberOfPostings > limit && (
        <Pagination page={page} setPage={setPage} limit={limit} numberOfPostings={numberOfPostings} isMobile />
      )}
    </div>
  );
}

const SpinnerWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  padding: 8px;
  z-index: 100;
  position: relative;
  margin-top: 40%;
`;

const PostingsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 44px;
`;

export default PostingsListMobile;
